import { getGeolocationServiceUrl } from '@repo/dot-env/geolocation-service-url'
import { z } from '@repo/schema'

import { fetchLookup } from './lookup-result.ts'

const expandedLinkSchema = z.object({ url: z.string() })

/** Expands a Google Maps short link into its full link, or null when it cannot be expanded. */
export const expandGoogleMapsLink = async (
  url: string,
  serviceUrl = getGeolocationServiceUrl(),
) => {
  const result = await fetchLookup(
    `${serviceUrl}/google/maps/expand?${new URLSearchParams({ url })}`,
    expandedLinkSchema,
    body => body.url,
  )

  return result.status === 'found' ? result.value : null
}
